import { makeStyles } from '@material-ui/core';

export const SelectStyle = makeStyles({
    root: {
        width: '100%',
    },
});
